import React, { useState, useEffect, useLayoutEffect } from "react";
import styled from "styled-components";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';

import PageContentWrapper from "../components/core/PageContentWrapper";
import Container from "../components/common/Container";
import FormHeader from "../components/form/FormHeader";
import FormTitle from "../components/form/FormTitle";
import FormField from "../components/form/FormField";
import FormText from "../components/form/FormText";
import FormInput from "../components/form/FormInput";
import FormLabel from "../components/form/FormLabel";
import FormRemark from "../components/form/FormRemark";
import FormInputError from "../components/form/FormInputError";
import ShadowBox from "../components/core/ShadowBox";
import Space from "../components/core/Space";
import Flex from "../components/core/Flex";
import Divider from "../components/core/Divider";
import FormButtonPrimary from "../components/form/FormButtonPrimary";
import FormButtonSecondary from "../components/form/FormButtonSecondary";
import NavigationBarClean from "../components/common/NavigationBarClean";
import useApplyProgressStore from "../store/useApplyProgressStore";
import withErrorHandling from "../function/withErrorHandling";
import { basename } from "../setting";

function ApplicationProgress() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fullname, setFullname, isFullnameError, setIsFullnameError } = useApplyProgressStore();
  const { refno, setRefno, isRefnoError, setIsRefnoError } = useApplyProgressStore();
  const { isAuthozied, setIsAuthozied, setData, userEnquiryStatus } = useApplyProgressStore();
  const { data } = useApplyProgressStore();

  // useEffect(() => { document.title = t("translation:progress.document_title") }, [i18n.language]);

  useLayoutEffect(() => {
    setIsAuthozied(false);
    setData({});
  }, []);

  const loadUserEnquiryStatus = withErrorHandling(userEnquiryStatus);

  const getProgrssStatus = ({
    step,
    intstatus,
    flowType,
  }) => {
    return <Flex gap={8}>
      {step === 1 && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}
      {(step === 2 && (intstatus === "NEW" || intstatus === "SUPPLE" || intstatus === "REVIEW")) && <IconProgress>2</IconProgress>}
      {(step === 2 && (intstatus === "APPROVELOG" || intstatus === "APPROVEPCA" || intstatus === "DECLINED" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}
      {(step === 3 && (intstatus === "NEW" || intstatus === "SUPPLE" || intstatus === "REVIEW")) && <IconProgress>3</IconProgress>}
      {(step === 3 && (intstatus === "APPROVELOG" || intstatus === "APPROVEPCA" || intstatus === "DECLINED" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}

      <Flex direction={"column"} gap={0}>
        {step === 1 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.request")}</FormText>}
        {step === 2 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.progressing")}</FormText>}
        {step === 3 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.result")}</FormText>}

        {step === 1 && <TextGreen>{t("translation:progress.status.submitted")}</TextGreen>}
        {(step === 2 && intstatus === "NEW") && <TextBlue>{t("translation:progress.status.pending_for_checking")}</TextBlue>}
        {(step === 2 && intstatus === "SUPPLE") && <TextBlue>{t("translation:progress.status.pending_for_supplementary_information")}</TextBlue>}
        {(step === 2 && intstatus === "REVIEW") && <TextBlue>{t("translation:progress.status.reviewing_supplementary_information")}</TextBlue>}
        {(step === 2 && (intstatus === "APPROVELOG" || intstatus === "APPROVEPCA" || intstatus === "DECLINED" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <TextBlue>{t("translation:progress.status.checked")}</TextBlue>}
        {(step === 3 && intstatus === "APPROVELOG") && <TextGreen>{t("translation:progress.status.approved_and_LOG_sent")}</TextGreen>}
        {(step === 3 && intstatus === "APPROVEPCA" && flowType === "PCA") && <TextGreen>{t("translation:progress.status.approved")}</TextGreen>}
        {(step === 3 && intstatus === "APPROVEPCA" && flowType === "CHGTOPCA") && <TextRed>{t("translation:progress.status.declined_and_changed_to_PCA")}</TextRed>}
        {(step === 3 && intstatus === "DECLINED") && <TextRed>{t("translation:progress.status.declined")}</TextRed>}
        {(step === 3 && (intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <TextGreen>{t("translation:progress.status.approved_and_LOG_sent")}</TextGreen>}
      </Flex>
    </Flex>
  };

  const getClaimProgrssStatus = ({
    step,
    intstatus,
    flowType,
  }) => {
    return <Flex gap={8}>
      {(step === 1 && (intstatus === "APPROVELOG")) && <IconProgress>1</IconProgress>}
      {(step === 1 && (intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}
      {(step === 2 && (intstatus === "APPROVELOG" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "OUTCHARGE")) && <IconProgress>2</IconProgress>}
      {(step === 2 && (intstatus === "CHARGESETTLE" || intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}
      {(step === 3 && (intstatus === "APPROVELOG" || intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "OUTCHARGE" || intstatus === "CHARGESETTLE")) && <IconProgress>3</IconProgress>}
      {(step === 3 && (intstatus === "CLAIMSETTLE")) && <Icon20 src={`${process.env.PUBLIC_URL}/images/tick_circle_light_blue.png`} alt="icon" />}

      <Flex direction={"column"} gap={0}>
        {step === 1 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.hospitalisation_or_surgery")}</FormText>}
        {step === 2 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.claim_progressing")}</FormText>}
        {step === 3 && <FormText style={{ fontSize: 12, lineHeight: "18px" }}>{t("translation:progress.status.claim_result")}</FormText>}

        {(step === 1 && (intstatus === "APPROVELOG")) && <TextBlue>{t("translation:progress.status.pending")}</TextBlue>}
        {(step === 1 && (intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE" || intstatus === "CHARGESETTLE" || intstatus === "OUTCHARGE" || intstatus === "CLAIMSETTLE")) && <TextGreen>{t("translation:progress.status.completed")}</TextGreen>}
        {(step === 2 && (intstatus === "PENDCHARGE" || intstatus === "SCHCHARGE")) && <TextBlue>{t("translation:progress.status.confirming")}</TextBlue>}
        {(step === 2 && (intstatus === "OUTCHARGE")) && <TextRed>{t("translation:progress.status.failed_to_chargeback")}</TextRed>}
        {(step === 2 && (intstatus === "CHARGESETTLE" || intstatus === "CLAIMSETTLE")) && <TextGreen>{t("translation:progress.status.chargeback_completed")}</TextGreen>}
        {(step === 3 && (intstatus === "OUTCHARGE")) && <TextRed>{t("translation:progress.status.settlement_failed")}</TextRed>}
        {(step === 3 && (intstatus === "CLAIMSETTLE")) && <TextGreen>{t("translation:progress.status.claim_settled")}</TextGreen>}
      </Flex>
    </Flex>
  };

  return (
    <PageContentWrapper>

      <NavigationBarClean />
      {
        isAuthozied ?
          <Container>
            <FormHeader>{t("translation:progress.result.header", { key: data?.form?.fullname })}</FormHeader>
            <FormText>{t("translation:progress.result.title")}</FormText>

            <Space height={32} />

            <ShadowBoxProgress>
              <Flex gap={8}>
                <Icon32 src={`${process.env.PUBLIC_URL}/images/medical-board-2.png`} alt="progress" />
                <FormTitle style={{ fontSize: 20, lineHeight: "30px" }}>{t("translation:progress.result.section1.header")}</FormTitle>
              </Flex>

              <Refno>{t("translation:progress.result.section1.refno", { key: data?.form?.refno })}</Refno>

              <Flex justifyContent={"flex-start"} style={{ flexWrap: "wrap", columnGap: 64, rowGap: 16 }}>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.insured_person")}</FormRemark>
                  <FormText>{data?.form?.fullname}</FormText>
                </Flex>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.policy_no")}</FormRemark>
                  <FormText>{data?.form?.IDPLNO}</FormText>
                </Flex>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.insured_person_no")}</FormRemark>
                  <FormText>{data?.form?.IDINSN}</FormText>
                </Flex>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.submit_date")}</FormRemark>
                  <FormText>{data?.form?.submitdt?.substr(0, 10) ?? "-"}</FormText>
                </Flex>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.moddt")}</FormRemark>
                  <FormText>{data?.form?.moddt?.substr(0, 10) ?? "-"}</FormText>
                </Flex>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.approval_date")}</FormRemark>
                  <FormText>{data?.form?.approvedt?.substr(0, 10) ?? "-"}</FormText>
                </Flex>
                <Flex direction={"column"} alignItems={"flex-start"}>
                  <FormRemark>{t("translation:progress.result.section1.housing_class")}</FormRemark>
                  <FormText>{i18n.language === "ch" ? data?.form?.lvOfAccommodationCh?.substr(0, 10) ?? "-" : data?.form?.lvOfAccommodationEn?.substr(0, 10) ?? "-"}</FormText>
                </Flex>
              </Flex>

              <Flex justifyContent={"flex-start"} gap={16}>
                {
                  getProgrssStatus({
                    step: 1,
                    intstatus: data?.form?.intstatus,
                    flowType: data?.form?.flowType,
                  })
                }
                <HDivider />
                {
                  getProgrssStatus({
                    step: 2,
                    intstatus: data?.form?.intstatus,
                    flowType: data?.form?.flowType,
                  })
                }
                <HDivider />
                {
                  getProgrssStatus({
                    step: 3,
                    intstatus: data?.form?.intstatus,
                    flowType: data?.form?.flowType,
                  })
                }
              </Flex>

              {
                (
                  data?.form?.intstatus === "APPROVELOG" ||
                  data?.form?.intstatus === "PENDCHARGE" ||
                  data?.form?.intstatus === "SCHCHARGE" ||
                  data?.form?.intstatus === "CHARGESETTLE" ||
                  data?.form?.intstatus === "OUTCHARGE" ||
                  data?.form?.intstatus === "CLAIMSETTLE"
                ) &&
                <Flex justifyContent={"flex-start"} gap={16}>
                  {
                    getClaimProgrssStatus({
                      step: 1,
                      intstatus: data?.form?.intstatus,
                      flowType: data?.form?.flowType,
                    })
                  }
                  <HDivider />
                  {
                    getClaimProgrssStatus({
                      step: 2,
                      intstatus: data?.form?.intstatus,
                      flowType: data?.form?.flowType,
                    })
                  }
                  <HDivider />
                  {
                    getClaimProgrssStatus({
                      step: 3,
                      intstatus: data?.form?.intstatus,
                      flowType: data?.form?.flowType,
                    })
                  }
                </Flex>
              }
            </ShadowBoxProgress>

            <Space height={24} />

            <Divider toBottom={true} />

            <StepNavBarContainer>
              <Navigation>
                <FormButtonSecondary onClick={() => {
                  navigate(`/${basename}/${i18n.language}`);
                }}>{t("backToHome")}</FormButtonSecondary>
              </Navigation>
            </StepNavBarContainer>
          </Container>
          :
          <Container>
            <FormHeader>{t("translation:progress.header")}</FormHeader>
            <FormText>{t("translation:progress.title")}</FormText>
            <Space height={24} />

            <FormField style={{ flex: 0 }}>
              <FormLabel htmlFor="name">{t("translation:progress.Q1")}</FormLabel>
              <FormInput id="name" value={fullname} handleChange={(e) => {
                setFullname(e.target.value);
                setIsFullnameError(false);
              }} placeholder={t("pleaseInput", { key: t("translation:progress.Q1") })} aria-label={t("translation:progress.Q1")} />
              <FormInputError show={isFullnameError}>* {t("pleaseInput", { key: t("translation:progress.Q1") })}</FormInputError>
            </FormField>

            <FormField style={{ flex: 0 }}>
              <FormLabel htmlFor="refno">{t("translation:progress.Q2")}</FormLabel>
              <FormInput id="refno" value={refno} handleChange={(e) => {
                setRefno(e.target.value);
                setIsRefnoError(false);
              }} placeholder={t("pleaseInput", { key: t("translation:progress.Q2") })} aria-label={t("translation:progress.Q2")} />
              <FormInputError show={isRefnoError}>* {t("pleaseInput", { key: t("translation:progress.Q2") })}</FormInputError>
            </FormField>

            <Space height={24} />

            <Divider toBottom={true} />

            <StepNavBarContainer>
              <Navigation>
                <FormButtonSecondary onClick={() => {
                  navigate(`/${basename}/${i18n.language}`);
                }}>{t("back")}</FormButtonSecondary>
                <FormButtonPrimary onClick={() => {
                  loadUserEnquiryStatus();
                }}>{t("next")}</FormButtonPrimary>
              </Navigation>
            </StepNavBarContainer>
          </Container>
      }

    </PageContentWrapper>
  );
}

const ShadowBoxProgress = styled(ShadowBox)`
  padding-top: 24px;
  padding-bottom: 24px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const IconProgress = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--aia-bx-gray-4);
  color: var(--aia-bx-gray-2);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 10px;
`;

const Icon32 = styled.img`
  width: 32px;
  height: 32px;
`;

const Refno = styled(FormText)`
  font-size: 12px;
  font-weight: bold;
  line-height: 18px;
  color: var(--aia-bx-dark-blue);
`;

const HDivider = styled.div`
  background-color: var(--aia-bx-dark-blue);
  width: 30px;
  height: 1px;
`;

const StepNavBarContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
}`;

const Navigation = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

const Icon20 = styled.img`
  width: 20px;
  height: 20px;
`;

const TextGreen = styled(FormText)`
  color: var(--aia-bx-green-60);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
`;

const TextBlue = styled(FormText)`
  color: var(--aia-bx-dark-blue);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
`;

const TextRed = styled(FormText)`
  color: var(--aia-bx-red-1);
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
`;

export default ApplicationProgress;